import { render, staticRenderFns } from "./staffSelector.vue?vue&type=template&id=17e2b507&scoped=true&"
import script from "./staffSelector.vue?vue&type=script&lang=js&"
export * from "./staffSelector.vue?vue&type=script&lang=js&"
import style0 from "./staffSelector.vue?vue&type=style&index=0&id=17e2b507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2b507",
  null
  
)

export default component.exports